/**
 * 認証ハブの実行環境判定（開発 vs 本番）
 * - 開発環境用URLを使う条件: -dev / staging を含む / localhost または 192.168.x 等
 */

const PRIVATE_IP_RE = /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3})$/;

/**
 * 現在のアプリの実行URLが「開発環境」とみなす条件かどうか
 * - ホストに "-dev" が含まれる
 * - ホストに "staging" が含まれる
 * - localhost または 127.0.0.1 または 192.168.x / 10.x / 172.16-31.x
 * @returns {boolean}
 */
export const isDevHubContext = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname || '';
  const lower = host.toLowerCase();
  if (lower.includes('-dev')) return true;
  if (lower.includes('staging')) return true;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  if (PRIVATE_IP_RE.test(host)) return true;
  return false;
};

/**
 * プロダクトの起動URLを環境に応じて返す
 * 開発環境かつ launchUrlDev が設定されていればそれを、それ以外は launchUrl を返す
 * @param {{ launchUrl?: string, launchUrlDev?: string }} product
 * @returns {string|null}
 */
export const getEffectiveLaunchUrl = (product) => {
  if (!product) return null;
  const prodUrl = product.launchUrl != null ? String(product.launchUrl).trim() : '';
  const devUrl = product.launchUrlDev != null ? String(product.launchUrlDev).trim() : '';
  if (isDevHubContext() && devUrl) return devUrl;
  return prodUrl || null;
};
